import { Helmet } from 'react-helmet';
import React from 'react';
import 'date-fns';
import axios from 'axios';
// import DateFnsUtils from '@date-io/date-fns';
import MomentUtils from '@date-io/moment';
import { useEffect, useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import {
  Box,
  Container,
  Grid,
  Card, CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
  // Pagination
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
// import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
// import ProductListToolbar from 'src/components/product/ProductListToolbar';
import ProductCard from 'src/components/product//ProductCard';
import Modal from '@material-ui/core/Modal';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './style.scss';
import { updateLocale } from 'moment';
import {
  GET_TREND_API,
  ADD_TREND_API,
  COLLECTIBLE_PAGING_API,
} from "../../apiContants";
import AlertNotice from "../../components/common/alertCommon";

const listOrder = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
const BootstrapInput = withStyles((theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  })
)(InputBase);

function getModalStyle() {
  const top = "50";
  const left = "50";

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  fieldID: {
    width: "400px",
    paddingTop: "15px!important",
  },
  gridn: {
    paddingTop: "15px!important",
  },
  papervalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    height: "25px",
    color: "black!important",
    borderRadius: "0px!important",
  },
  paper: {
    fontSize: "20px",
  },
  modal: {
    position: "absolute",
    width: 700,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modaladv: {
    position: "absolute",
    width: "700!important",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));
const ProductList = () => {
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [openadv, setOpenadv] = React.useState(false);
  const [openadditem, setOpenadditem] = React.useState(false);
  const [openView, setView] = React.useState(false);
  const classes = useStyles();
  const [reg, regSet] = useState(Array);
  const [regs, regSetadv] = useState(Array);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [productlist, setproductlist] = useState(reg);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = React.useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [alertContent, setAlertContent] = useState(null);
  const handleChange = (event) => {
    setOrder(event.target.value);
  };
  const [value, setValues] = React.useState({
    name: "",
  });
  const handleChangeForm = (name) => (event) => {
    setValues({ ...value, [name]: event.target.value });
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleOpen = (product, idx) => {
    setValues({ name: product?.collectible.id });
    setproductlist(product);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenadv = () => {
    setOpenadv(true);
  };

  const handleCloseadv = () => {
    setOpenadv(false);
  };
  const handleOpenadditem = () => {
    setOpenadditem(true);
  };

  const handleCloseadditem = () => {
    setOpenadditem(false);
  };
  const handleView = () => {
    setView(true);
  };

  const handleCloseView = () => {
    setView(false);
  };

  const GetTrend = async () => {
    const update = await axios.get(GET_TREND_API);
    const GetTrend1 = update.data.trend;
    const sorted = GetTrend1.sort((a, b) => {
      return a.order - b.order;
    });
    regSet(sorted);
  };
  const GetAdvertisement = async () => {
    const advertisementlist = await axios.get(GET_TREND_API);
    const GetTrend12 = advertisementlist.data.trend;
    const adv = GetTrend12.filter((element) => {
      return element.advertisement === true;
    });
    regSetadv(adv);
  };
  const PostTrend = async () => {
    const post_trend = await axios
      .post(ADD_TREND_API + `collectible_id=${value.name}&order=${order}`)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        setAlertContent("Id is not valid !");
        setOpenAlert(true);
      });

    if (post_trend?.status === 200) {
      setAlertContent("Add Trend Success !");
      setOpenAlert(true);
      setLoading(!loading);
      handleCloseView();
      GetTrend();
    }
  };
  const PostAdvertisement = async () => {
    const post_advertisement = await axios.post(
      ADD_TREND_API + `collectible_id=${value.name}&order=${order}`
    );
    if (post_advertisement?.status === 200) {
      setAlertContent("Add Trend Success !");
      setOpenAlert(true);
      setLoading(!loading);
      handleCloseView();
    }
  };
  const DeleteTrend = async () => {
    const delete_trend = await axios.delete(
      GET_TREND_API + `?id=${productlist.id}&order=${productlist.order}`
    );
    if (delete_trend?.status === 200) {
      setAlertContent("Delete Trend Success !");
      setOpenAlert(true);
      handleClose(false);
      GetTrend();
    }
  };

  useEffect(() => {
    GetTrend();
    GetAdvertisement();
  }, [loading]);

  const body = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Enter item ID to add the item to Trend view</h2>
        <TextField
          onChange={handleChangeForm("name")}
          className={classes.fieldID}
          placeholder="enter ID"
          inputProps={{ min: 0, style: { textAlign: "center" } }}
          id="standard-basic"
          value={value.name}
          disabled={true}
        />
        <Grid className={classes.gridn} container spacing={3}>
          <Grid item xs={12} md={12}>
            <Button
              onClick={() => DeleteTrend()}
              color="primary"
              fullWidth
              size="large"
              variant="contained"
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  const bodyView = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Add new item to Advertisement list</h2>
        <Grid justifyContent="center" alignItems="center" spacing={1} container>
          <Grid item xs={3}>
            <span className={classes.paper}>Item ID</span>
          </Grid>
          <Grid className={classes.mui} item xs={9}>
            <TextField
              onChange={handleChangeForm("name")}
              className="containt"
              placeholder="enter Item ID"
              inputProps={{
                min: 0,
                style: { textAlign: "center", width: "250px" },
              }}
              id="standard-basic"
            />
          </Grid>
          <Grid item xs={3}>
            <span className={classes.paper}>Order</span>
          </Grid>
          <Grid className={classes.mui} item xs={9}>
            <FormControl className={classes.margin}>
              <InputLabel htmlFor="demo-customized-select-native">
                Order
              </InputLabel>
              <NativeSelect
                id="demo-customized-select-native"
                value={order}
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="" />
                {listOrder.map((orderr, idx) => (
                  <option value={orderr}>{orderr}</option>
                ))}
                <option value={30}>Thirty</option>
              </NativeSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              onClick={() => PostTrend()}
              fullWidth
              size="large"
              variant="contained"
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  const bodyadv = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Advertisement list</h2>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pb: 3,
          }}
        >
          <Button onClick={handleOpenadditem} type="button">
            Add Item
          </Button>
        </Box>
        <PerfectScrollbar>
          <Box sx={{ maxWidth: 650 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Item ID</TableCell>
                  <TableCell>Expiration Date</TableCell>
                  <TableCell>More</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {regs.map((customer, idx) => (
                  <TableRow hover key={customer.id}>
                    <TableCell>
                      {customer.advertisement === true
                        ? customer.collectible.id
                        : ""}
                    </TableCell>
                    <TableCell>{/* {customer.date} */}T.B.D</TableCell>
                    <TableCell>
                      <Button type="button">delete</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
      </div>
    </Box>
  );
  const bodyadditem = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Add new item to Advertisement list</h2>
        <Grid justifyContent="center" alignItems="center" spacing={1} container>
          <Grid item xs={3}>
            <span className={classes.paper}>Wallet ADD</span>
          </Grid>
          <Grid className={classes.mui} item xs={9}>
            <TextField
              onChange={handleChangeForm("name")}
              className="containt"
              placeholder="enter wallet address"
              inputProps={{
                min: 0,
                style: { textAlign: "center", width: "250px" },
              }}
              id="standard-basic"
            />
          </Grid>
          <Grid item xs={3}>
            <span className={classes.paper}>Expiration date</span>
          </Grid>
          <Grid className={classes.mui} item xs={9}>
            <MuiPickersUtilsProvider
              className={classes.mui}
              utils={MomentUtils}
            >
              <Grid container justifyContent="flex-start">
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  margin="normal"
                  id="date-picker-inline"
                  // label="Date picker inline"
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              onClick={() => PostAdvertisement()}
              fullWidth
              size="large"
              variant="contained"
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  return (
    <>
      <Helmet>
        <title>Products | Material Kit</title>
      </Helmet>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ minWidth: 700 }}>
              <Button onClick={handleOpenadv} type="button">
                Advertisement list
              </Button>
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={handleView}
              >
                add new
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <Grid container spacing={3}>
              {reg.map((product, idx) => (
                <Grid item key={product} lg={3} md={6} xs={12}>
                  <button
                    type="button"
                    onClick={() => handleOpen(product, idx)}
                  >
                    <ProductCard product={product} />
                  </button>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box textAlign="center">
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              {body}
            </Modal>
          </Box>
          <Box textAlign="center">
            <Modal
              className={classes.modaladv}
              open={openadv}
              onClose={handleCloseadv}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              {bodyadv}
            </Modal>
          </Box>
          <Box textAlign="center">
            <Modal
              className={classes.modaladv}
              open={openadditem}
              onClose={handleCloseadditem}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              {bodyadditem}
            </Modal>
          </Box>
          <Box textAlign="center">
            <Modal
              className={classes.modaladv}
              open={openView}
              onClose={handleCloseView}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              {bodyView}
            </Modal>
          </Box>
          <AlertNotice
            openAlert={openAlert}
            setOpenAlert={setOpenAlert}
            alertContent={alertContent}
          ></AlertNotice>
        </Container>
      </Box>
    </>
  );
};

export default ProductList;
